import styled, { css } from 'styled-components';

import { media } from 'utils/detection';
import withParallax from 'utils/parallax';

export default withParallax(styled.p`
  font-family: 'Galano Classic';
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.46rem;
  padding: 0;
  margin: 0;

  ${media.medium`
    font-size: 1.4vw;
    line-height: 3vw;
  `}

  ${media.large`
    font-size: 1vw;
    line-height: 2.6vw;
  `}

  ${props =>
    props.big &&
    css`
      font-size: 25px;
      line-height: 33.33px;

      ${media.medium`
      font-size: 2.45vw;
      line-height: 4.05vw;
    `}
    `}
`);
